import React from 'react'
import { Box, Flex, Divider, Text } from '@chilipiper/design-system'
import { Avatar, IconButton } from '@chilipiper/design-system/src/new'
import { IconRepeatingEvent, IconX } from '@chilipiper/icons/figma-generated/src/icon'
import { motion } from 'framer-motion'
import { StyledAvatarImage } from '../styles'
import { Channel } from '../types'

interface Props {
  channel: Channel
  hasDivider?: boolean
  isDividerFullWidth?: boolean
  onClose?: () => void
  onRestart?: () => void
  showRestart: boolean
  isRestarting?: boolean
}

const HeaderAvatar = ({ channel }: { channel: Channel }) => {
  if (typeof channel.avatar !== 'string') {
    return (
      <Box h='40px' w='40px'>
        {channel.avatar}
      </Box>
    )
  }
  if (channel.type === 'bot' || channel.type === 'piper-ai') {
    return <StyledAvatarImage size='40px' borderRadius='10px' src={channel.avatar} alt='' />
  }
  return <Avatar id={channel.id} name={channel.fullName} image={channel.avatar} size={8} />
}

export const Header = ({
  channel,
  isDividerFullWidth = false,
  onClose,
  hasDivider = true,
  showRestart,
  onRestart,
  isRestarting,
}: Props) => (
  <Box flex={1}>
    <Flex alignItems='center' justifyContent='space-between' p='section'>
      <Flex alignItems='center' gap={3}>
        <HeaderAvatar channel={channel} />
        <Text color='fg/major' textStyle='page-section-heading' data-test-id='WidgetHeader-name'>
          {channel.fullName}
        </Text>
      </Flex>
      <Flex alignItems='center' gap={2}>
        {showRestart && onRestart && (
          <IconButton
            size={7}
            label='Start over'
            icon={IconRepeatingEvent}
            isDisabled={isRestarting}
            onClick={onRestart}
            data-test-id='WidgetHeader-restart'
            variant='ghost'
          />
        )}
        <IconButton
          size={7}
          label='Close chat'
          icon={IconX}
          onClick={onClose}
          data-test-id='WidgetHeader-close'
          variant='ghost'
        />
      </Flex>
    </Flex>
    {hasDivider && <AnimatedThemedDivider layout mx={isDividerFullWidth ? 0 : 'section'} />}
  </Box>
)

const AnimatedThemedDivider = motion(Divider)
